import React, { useEffect, useState } from 'react'
import { Button, Col, Image, Row, Spin } from "antd";
import { useHistory, Link } from 'react-router-dom';
import MonogramIcon from "assets/images/mongram.jpg";
import { baseImageURL } from 'utils/env';
import { toastMessage, useGlobalMerchant } from 'utils/helper';
import { useBasket } from 'containers/POSContainer/constant';

const ECSPDetailComponent = ({ addedToCart, setAddedToCart }: any) => {
    const { addToBasketWithQty, removeFromBasket, addToExistingBasket, itemList } = useBasket();
    const { productContent, setProductContent, globalMerchantCurrency } = useGlobalMerchant();
    const [pCount, setPCount] = useState<any>();
    const history = useHistory();

    const onBackToProducts = () => {
        setProductContent({});
        window.history.go(-1);
    }

    const removeFromCart = (productId: string) => {
        removeFromBasket(productId);
        setAddedToCart((prevAddedToCart: any) => ({ ...prevAddedToCart, [productId]: false, }));
        toastMessage("Item removed from basket");
    };


    const addToCart = (productId: string, product: any) => {
        addToBasketWithQty(product, pCount);
        setAddedToCart((prevAddedToCart: any) => ({ ...prevAddedToCart, [productId]: true, }));
        toastMessage("Item added to basket");
    };

    const handleCartAction = (productId: string, product: any) => {
        if (productContent.qty == 0) { return; }
        addedToCart[productId] ? removeFromCart(productId) : addToCart(productId, product);
    };

    const handlePlusAction = () => {
        if (addedToCart[productContent.product_id]) { return; }
        productContent.qty > pCount && setPCount((pCount: any) => pCount += 1)
    }

    const handleMinusAction = () => {
        if (addedToCart[productContent.product_id]) { return; }
        pCount != 1 && setPCount((pCount: any) => pCount -= 1)
    }

    const productQuantity = () => {
        if (itemList && itemList.length > 0) {
            const matchedProduct = itemList.find((item: any) => item.product.product_id === productContent.product_id);
            if (matchedProduct) { return matchedProduct.qty; }
        }
        return 1;
    };

    useEffect(() => {
        const getQty = productQuantity();
        setPCount(getQty);
    }, [])

    return (
        <div className="singleProductSection">
            {Object.keys(productContent).length > 0 ? (
                <Row gutter={{ xs: 20, sm: 20, md: 20, lg: 20 }} align={"stretch"} justify={"space-between"}>
                    <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 11 }} lg={{ span: 11 }}>
                        <div className="left dFlex alignCenter justifyCenter">
                            <div className="sPImage">
                                <Image
                                    src={productContent.img !== null ? `${baseImageURL}${productContent.img}` : MonogramIcon}
                                    alt="product image"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                        <div className="right">
                            <div className="sPHeader">
                                <h2 className="sLgText pCardTitle textUpper">{productContent.product_name}</h2>
                            </div>
                            <div className="sPBody mb50 mt30">
                                <div className="dFlex alignCenter gap10">
                                    <p className="pCardAmount sMdText">{productContent.price} {globalMerchantCurrency}</p>
                                    <div className={productContent.qty <= 0 ? "disable stock" : "stock"}>
                                        {productContent.qty <= 0 ? <p className='disable sSmText'>Sold out</p> : <p className='sSmText'>In stock</p>}
                                    </div>
                                </div>
                                <div className="pCardQuantity mt30">
                                    <p className="sSmText mb5 fontMedium">Quantity</p>
                                    <div className="inlineFlex alignBaseline gap30 pCardQuantityBtn">
                                        <Button disabled={addedToCart[productContent.product_id]} onClick={() => handleMinusAction()} >
                                            -
                                        </Button>
                                        <span className="pCardQuantityNum sMdText">{productContent.qty == 0 ? 0 : pCount}</span>
                                        <Button disabled={addedToCart[productContent.product_id]} onClick={() => handlePlusAction()}>
                                            +
                                        </Button>
                                    </div>
                                </div>
                                <p className="sSmText mt20 fontMedium">Available Quantity: {productContent.qty}</p>
                                <p className="pCardContent mt20 sNmText">   {productContent.description} </p>
                            </div>
                            <div className="sPFooter dFlex alignCenter justifyBetween">
                                {/* <div className="leftBtn sBtn" onClick={() => productContent.qty > 0 && handleCartAction(productContent.product_id, productContent)}>Add to cart</div> */}
                                <Button
                                    className={addedToCart[productContent.product_id] ? "sBtn remove" : "sBtn add"}
                                    onClick={() => handleCartAction(productContent.product_id, productContent)}
                                >
                                    {addedToCart[productContent.product_id] ? "Remove From Cart" : "Add To Cart"}
                                </Button>
                                <div className="rightBtn sBtn sBtnSecondary textUnderline" onClick={() => onBackToProducts()}>Back to products</div>
                            </div>
                        </div>
                    </Col>
                </Row>
            ) : (
                <p>Something went wrong</p>
            )}
        </div>
    )
}

export default ECSPDetailComponent